// @ts-nocheck
export * from "./text";
